"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonType = exports.ButtonClass = void 0;
const react_1 = __importDefault(require("react"));
var ButtonClass;
(function (ButtonClass) {
    ButtonClass["BASIC"] = "basic";
    ButtonClass["DESTRUCTIVE"] = "destructive";
    ButtonClass["PREFERRED"] = "preferred";
    ButtonClass["QUIET"] = "quiet";
})(ButtonClass = exports.ButtonClass || (exports.ButtonClass = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["SUBMIT"] = "submit";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
exports.Button = (props) => {
    const { autoFocus, buttonClass = ButtonClass.BASIC, className, disabled, icon, onClick, propagateClick = false, text, type = ButtonType.BUTTON, } = props;
    const classes = [
        'button',
        buttonClass.toString(),
        className,
        disabled && 'disabled',
        icon && 'icon',
    ].filter(Boolean).join(' ');
    const handleClick = (event) => {
        if (!propagateClick) {
            event.stopPropagation();
        }
        if (!disabled) {
            onClick(event);
        }
    };
    return (react_1.default.createElement("button", { autoFocus: autoFocus, type: type, className: classes, onClick: handleClick },
        icon &&
            icon,
        react_1.default.createElement("div", { className: icon ? 'icon-button-text' : 'button-text' }, text)));
};
exports.default = exports.Button;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2J1dHRvbnMvQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFHeUM7QUFHekMsSUFBWSxXQUtYO0FBTEQsV0FBWSxXQUFXO0lBQ25CLDhCQUFxQixDQUFBO0lBQ3JCLDBDQUEyQixDQUFBO0lBQzNCLHNDQUF5QixDQUFBO0lBQ3pCLDhCQUFxQixDQUFBO0FBQ3pCLENBQUMsRUFMVyxXQUFXLEdBQVgsbUJBQVcsS0FBWCxtQkFBVyxRQUt0QjtBQUVELElBQVksVUFHWDtBQUhELFdBQVksVUFBVTtJQUNsQiwrQkFBc0IsQ0FBQTtJQUN0QiwrQkFBc0IsQ0FBQTtBQUMxQixDQUFDLEVBSFcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFHckI7QUFjWSxRQUFBLE1BQU0sR0FBNkIsQ0FBQyxLQUFZLEVBQUUsRUFBRTtJQUU3RCxNQUFNLEVBQ0YsU0FBUyxFQUNULFdBQVcsR0FBTSxXQUFXLENBQUMsS0FBSyxFQUNsQyxTQUFTLEVBQ1QsUUFBUSxFQUNSLElBQUksRUFDSixPQUFPLEVBQ1AsY0FBYyxHQUFHLEtBQUssRUFDdEIsSUFBSSxFQUNKLElBQUksR0FBYSxVQUFVLENBQUMsTUFBTSxHQUNyQyxHQUFHLEtBQUssQ0FBQztJQUVWLE1BQU0sT0FBTyxHQUFHO1FBQ1osUUFBUTtRQUNSLFdBQVcsQ0FBQyxRQUFRLEVBQUU7UUFDdEIsU0FBUztRQUNULFFBQVEsSUFBSSxVQUFVO1FBQ3RCLElBQUksSUFBSSxNQUFNO0tBQ2pCLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUU1QixNQUFNLFdBQVcsR0FBRyxDQUFDLEtBQXNELEVBQUUsRUFBRTtRQUMzRSxJQUFJLENBQUMsY0FBYyxFQUFFO1lBQ2pCLEtBQUssQ0FBQyxlQUFlLEVBQUUsQ0FBQztTQUMzQjtRQUVELElBQUksQ0FBQyxRQUFRLEVBQUU7WUFDWCxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUE7U0FDakI7SUFDTCxDQUFDLENBQUE7SUFFRCxPQUFPLENBQ0gsMENBQ0ksU0FBUyxFQUFLLFNBQVMsRUFDdkIsSUFBSSxFQUFVLElBQUksRUFDbEIsU0FBUyxFQUFLLE9BQU8sRUFDckIsT0FBTyxFQUFPLFdBQVc7UUFFeEIsSUFBSTtZQUNELElBQUk7UUFFUix1Q0FBSyxTQUFTLEVBQUksSUFBSSxDQUFDLENBQUMsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsYUFBYSxJQUNyRCxJQUFJLENBQ0osQ0FDRCxDQUNaLENBQUM7QUFFTixDQUFDLENBQUM7QUFFRixrQkFBZSxjQUFNLENBQUMifQ==